// extracted by mini-css-extract-plugin
module.exports = {"root":"PrimaryImage__root--1iuS-"};